import { createSvgIcon } from '@mui/material';
import React from 'react';

export const DriverProgressCircle = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM4.8 24C4.8 34.6039 13.3961 43.2 24 43.2C34.6039 43.2 43.2 34.6039 43.2 24C43.2 13.3961 34.6039 4.8 24 4.8C13.3961 4.8 4.8 13.3961 4.8 24Z"
      fill="#E0E0E0"
    />
    <path
      d="M24 2.4C24 1.07452 25.0772 -0.0124339 26.3961 0.119894C29.9812 0.479611 33.4503 1.64328 36.54 3.53664C40.3139 5.84929 43.3747 9.16051 45.3842 13.1042C47.3936 17.0479 48.2733 21.4705 47.926 25.883C47.5787 30.2955 46.018 34.526 43.4164 38.1068C40.8148 41.6877 37.2736 44.4793 33.1844 46.1731C29.0952 47.8669 24.6172 48.3969 20.2456 47.7045C15.8739 47.0121 11.7789 45.1243 8.41325 42.2497C5.65779 39.8964 3.47908 36.9567 2.02909 33.6581C1.49569 32.4447 2.19657 31.0844 3.45718 30.6748C4.71779 30.2652 6.05834 30.9638 6.62191 32.1635C7.77828 34.6251 9.44866 36.8216 11.5306 38.5998C14.2231 40.8994 17.4991 42.4097 20.9965 42.9636C24.4938 43.5175 28.0761 43.0935 31.3475 41.7385C34.6189 40.3834 37.4518 38.1501 39.5331 35.2855C41.6144 32.4208 42.863 29.0364 43.1408 25.5064C43.4186 21.9764 42.7149 18.4384 41.1073 15.2834C39.4998 12.1284 37.0511 9.47943 34.032 7.62931C31.6975 6.19874 29.0923 5.28889 26.3938 4.9498C25.0787 4.78454 24 3.72548 24 2.4Z"
      fill="#006B69"
    />
    <path
      d="M8.72649 39.2735C7.78923 40.2108 6.25888 40.2176 5.41986 39.1915C2.17488 35.2228 0.271854 30.2998 0.0269576 25.1372C-0.217939 19.9746 1.21052 14.8935 4.06525 10.6356C4.80337 9.5346 6.32751 9.39655 7.34928 10.2409C8.37105 11.0852 8.50027 12.5914 7.78991 13.7104C5.68122 17.0324 4.6333 20.941 4.82157 24.9098C5.00983 28.8786 6.42304 32.6704 8.83672 35.7778C9.64982 36.8246 9.66375 38.3362 8.72649 39.2735Z"
      fill="white"
    />
    <path
      d="M7.93821 38.4423C6.95258 39.3285 5.42401 39.2542 4.64057 38.185C1.61057 34.0499 -0.0287732 29.0329 0.000381859 23.8646C0.0295369 18.6963 1.72538 13.6981 4.80184 9.59746C5.59729 8.53719 7.1266 8.48014 8.10217 9.37745C9.07774 10.2748 9.12693 11.7857 8.35824 12.8655C6.07639 16.0709 4.82272 19.9185 4.8003 23.8917C4.77789 27.8649 5.98807 31.7263 8.23361 34.9573C8.99007 36.0458 8.92384 37.556 7.93821 38.4423Z"
      fill="#4CA7A6"
    />
  </svg>
);

export const TripPlanV2TimelineTab1 = ({ color = '#001122' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6"
        cy="6"
        r="4.5"
        stroke={color}
        strokeOpacity="1"
        strokeWidth="3"
      />
    </svg>
  );
};

export const TripPlanV2TimelineTab2 = ({ color = '#001122' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6"
        cy="6"
        r="4.5"
        stroke={color}
        strokeOpacity="1"
        strokeWidth="3"
      />
      <circle cx="20" cy="6" r="4" fill={color} fillOpacity="1" />
    </svg>
  );
};

export const TripPlanV2TimelineTab3 = ({ color = '#001122' }) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6"
        cy="6"
        r="4.5"
        stroke={color}
        strokeOpacity="1"
        strokeWidth="3"
      />
      <circle cx="20" cy="6" r="4" fill={color} fillOpacity="1" />
      <circle cx="30" cy="6" r="2" fill={color} fillOpacity="1" />
    </svg>
  );
};

export const TripPlanV2TimelineTruck = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.35355 14.6464C2.78739 12.0803 2.78739 7.91972 5.35355 5.35355C7.91972 2.78739 12.0803 2.78739 14.6464 5.35355C17.2126 7.91972 17.2126 12.0803 14.6464 14.6464L10 19.2929L5.35355 14.6464Z"
      fill="white"
      stroke="white"
    />
    <path
      d="M10.525 6.57742L8.91832 6.54248L8.8397 10.1575L5.22467 10.0789L5.2072 10.8822L5.49239 10.8884C5.39965 11.0889 5.37499 11.3141 5.42218 11.5299C5.45965 11.6992 5.54049 11.8558 5.65675 11.9845C5.77301 12.1131 5.92071 12.2093 6.08536 12.2636C6.23468 12.3135 6.39362 12.3276 6.54937 12.3047C6.70511 12.2818 6.8533 12.2227 6.98199 12.132C7.11067 12.0413 7.21624 11.9217 7.29018 11.7827C7.36412 11.6437 7.40436 11.4893 7.40765 11.332C7.40478 11.4638 7.42792 11.595 7.47573 11.7179C7.52355 11.8408 7.59511 11.9531 7.68633 12.0484C7.77754 12.1437 7.88664 12.2201 8.00737 12.2732C8.1281 12.3263 8.25812 12.3551 8.38999 12.358C8.65631 12.3638 8.91403 12.2635 9.10644 12.0793C9.29886 11.8951 9.41021 11.6419 9.416 11.3756L11.4244 11.4193C11.4186 11.6856 11.5188 11.9433 11.703 12.1358C11.8873 12.3282 12.1404 12.4395 12.4067 12.4453C12.673 12.4511 12.9307 12.3509 13.1231 12.1666C13.3156 11.9824 13.4269 11.7293 13.4327 11.463L14.0352 11.4761L14.0527 10.6727C14.0596 10.3531 13.9393 10.0439 13.7183 9.81299C13.4972 9.58209 13.1935 9.44847 12.8739 9.44152L12.4722 9.43279L12.4897 8.62945C12.4943 8.41639 12.4141 8.21021 12.2667 8.05628C12.1194 7.90235 11.9169 7.81327 11.7038 7.80864C11.7108 7.48905 11.5905 7.17979 11.3694 6.94889C11.1483 6.71799 10.8446 6.58437 10.525 6.57742ZM6.39474 11.7118C6.28821 11.7095 6.18697 11.6649 6.11328 11.588C6.03959 11.511 5.99949 11.4079 6.00181 11.3014C6.00412 11.1948 6.04866 11.0936 6.12563 11.0199C6.20259 10.9462 6.30568 10.9061 6.41221 10.9084C6.51874 10.9108 6.61999 10.9553 6.69368 11.0323C6.76737 11.1092 6.80746 11.2123 6.80515 11.3188C6.80283 11.4254 6.75829 11.5266 6.68132 11.6003C6.60436 11.674 6.50127 11.7141 6.39474 11.7118ZM8.40309 11.7555C8.29656 11.7531 8.19532 11.7086 8.12163 11.6316C8.04794 11.5547 8.00784 11.4516 8.01016 11.3451C8.01247 11.2385 8.05701 11.1373 8.13398 11.0636C8.21095 10.9899 8.31403 10.9498 8.42056 10.9521C8.52709 10.9544 8.62834 10.999 8.70203 11.0759C8.77572 11.1529 8.81581 11.256 8.8135 11.3625C8.81118 11.4691 8.76664 11.5703 8.68967 11.644C8.61271 11.7177 8.50962 11.7578 8.40309 11.7555ZM11.6689 9.41532L10.4639 9.38911L10.4813 8.58577L11.6863 8.61198L11.6689 9.41532ZM12.4198 11.8428C12.3133 11.8405 12.212 11.796 12.1383 11.719C12.0646 11.642 12.0245 11.5389 12.0269 11.4324C12.0292 11.3259 12.0737 11.2246 12.1507 11.1509C12.2276 11.0772 12.3307 11.0372 12.4373 11.0395C12.5438 11.0418 12.645 11.0863 12.7187 11.1633C12.7924 11.2403 12.8325 11.3433 12.8302 11.4499C12.8279 11.5564 12.7833 11.6576 12.7064 11.7313C12.6294 11.805 12.5263 11.8451 12.4198 11.8428Z"
      fill="#35446B"
      fillOpacity="0.89"
    />
  </svg>,
  'TripPlanV2TimelineTruck'
);

export const TripPlanV2TimelineDriverRM = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.35999 11.8C9.92999 11.68 10.49 11.59 11.07 11.52C12.5855 11.337 14.1228 11.4941 15.57 11.98C16.1348 12.215 16.628 12.5943 17 13.08C17.92 14.4 18.73 15.79 19.56 17.17C19.8439 17.6875 19.9315 18.2901 19.8065 18.867C19.6816 19.4439 19.3526 19.9563 18.88 20.31C18.2784 20.4791 17.6474 20.5166 17.03 20.42C16.97 20.42 16.9 20.18 16.86 20.04C16.699 19.0993 16.2346 18.2372 15.5376 17.5854C14.8406 16.9335 13.9493 16.5277 13 16.43C12.8355 16.3981 12.679 16.3335 12.54 16.24C12.46 16.24 12.42 16.07 12.35 15.97C11.37 14.63 10.41 13.28 9.35999 11.8ZM12.19 11C11.2332 10.9584 10.3319 10.5394 9.68336 9.83466C9.03486 9.12994 8.69205 8.19695 8.72999 7.24C8.70991 6.76684 8.78364 6.29437 8.94695 5.84983C9.11026 5.40529 9.3599 4.99745 9.68152 4.64981C10.0031 4.30217 10.3903 4.0216 10.8209 3.82427C11.2514 3.62693 11.7167 3.51672 12.19 3.5C12.6699 3.51405 13.1422 3.6229 13.5799 3.82026C14.0175 4.01763 14.4118 4.29962 14.74 4.65C15.0683 5.00119 15.3202 5.41659 15.48 5.87C15.6443 6.32103 15.7158 6.80065 15.69 7.28C15.6993 8.22739 15.3408 9.14147 14.69 9.83C14.3711 10.1803 13.986 10.4641 13.5569 10.6649C13.1279 10.8657 12.6633 10.9796 12.19 11ZM11.75 16.41C10.7184 16.4532 9.73186 16.8443 8.95103 17.5199C8.1702 18.1954 7.64112 19.1154 7.44999 20.13C7.40666 20.224 7.34153 20.3063 7.25999 20.37C7.17771 20.4361 7.08224 20.4838 6.97999 20.51C6.59166 20.6147 6.17892 20.58 5.81353 20.4119C5.44814 20.2438 5.1532 19.953 4.97999 19.59C4.69272 19.2238 4.52839 18.7763 4.51044 18.3112C4.49248 17.8461 4.62181 17.3872 4.87999 17C5.67999 15.79 6.37999 14.53 7.16999 13.29C7.28688 13.0809 7.42784 12.8863 7.58999 12.71C8.28999 11.93 8.67999 11.95 9.26999 12.8L11.75 16.41ZM15.75 20.48H8.55999C8.52402 20.0306 8.62514 19.5808 8.84999 19.19C9.08148 18.7859 9.43019 18.4616 9.84999 18.26C10.4976 17.8152 11.2545 17.5559 12.0388 17.51C12.8231 17.4642 13.605 17.6336 14.3 18C14.7599 18.2176 15.1458 18.5653 15.41 19C15.6775 19.4277 15.8099 19.926 15.79 20.43L15.75 20.48Z"
      fill="#001122"
      fillOpacity="0.6"
    />
  </svg>
);

export const TripPlanV2TimelineArrowUp = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8L1.41 9.41L7 3.83V16H9V3.83L14.58 9.42L16 8L8 0L0 8Z"
      fill="#001122"
      fillOpacity="0.6"
    />
  </svg>
);

export const TripPlanV2TimelineOilChange = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.83334 11.6663C9.97127 11.906 10.0264 12.1844 9.99028 12.4586C9.95413 12.7327 9.82868 12.9873 9.63333 13.183C9.51784 13.2999 9.38029 13.3927 9.22866 13.4561C9.07703 13.5194 8.91433 13.5521 8.75 13.5521C8.58567 13.5521 8.42297 13.5194 8.27134 13.4561C8.11971 13.3927 7.98216 13.2999 7.86667 13.183C7.67132 12.9873 7.54587 12.7327 7.50972 12.4586C7.47357 12.1844 7.52873 11.906 7.66666 11.6663L8.75 9.79968L9.83334 11.6663ZM20 4.16634V5.83301H18.8333L13 16.6663H3.33333V5.83301H1.66667V8.33301H0V4.16634H5V6.66634H8.33333V4.99967H6.66667V3.33301H11.6667V4.99967H10V6.66634H13.3333V7.54967L18.0667 4.16634H20ZM15.9 7.76634L11.6667 10.783V8.33301H5V14.9997H12L15.9 7.76634Z"
      fill="#BDBDBD"
    />
  </svg>
);

export const Tractor02V2 = ({ color = 'white' }) => {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.515 0.506805H7.48469V7.32499H0.666504V8.84014H1.20438C1.03777 9.2218 1.00053 9.64747 1.09832 10.0523C1.17591 10.3699 1.33472 10.6618 1.55917 10.8996C1.78362 11.1373 2.066 11.3126 2.37863 11.4083C2.66215 11.4962 2.96236 11.5162 3.25503 11.4667C3.5477 11.4172 3.82464 11.2996 4.06352 11.1234C4.30239 10.9472 4.4965 10.7173 4.63019 10.4523C4.76388 10.1873 4.83341 9.89454 4.83317 9.59771C4.83317 9.84643 4.88216 10.0927 4.97734 10.3225C5.07252 10.5523 5.21202 10.7611 5.38789 10.9369C5.56376 11.1128 5.77255 11.2523 6.00233 11.3475C6.23211 11.4427 6.47839 11.4917 6.72711 11.4917C7.22941 11.4917 7.71114 11.2921 8.06632 10.9369C8.42151 10.5817 8.62105 10.1 8.62105 9.59771H12.4089C12.4089 10.1 12.6085 10.5817 12.9637 10.9369C13.3188 11.2921 13.8006 11.4917 14.3029 11.4917C14.8052 11.4917 15.2869 11.2921 15.6421 10.9369C15.9973 10.5817 16.1968 10.1 16.1968 9.59771H17.3332V8.08256C17.3332 7.4798 17.0937 6.90172 16.6675 6.4755C16.2413 6.04928 15.6632 5.80984 15.0604 5.80984H14.3029V4.29468C14.3029 3.89284 14.1432 3.50746 13.8591 3.22331C13.5749 2.93916 13.1896 2.77953 12.7877 2.77953C12.7877 2.17677 12.5483 1.59869 12.1221 1.17247C11.6958 0.746254 11.1178 0.506805 10.515 0.506805ZM2.93923 10.3553C2.73831 10.3553 2.54562 10.2755 2.40354 10.1334C2.26147 9.99133 2.18166 9.79864 2.18166 9.59771C2.18166 9.39679 2.26147 9.2041 2.40354 9.06203C2.54562 8.91995 2.73831 8.84014 2.93923 8.84014C3.14015 8.84014 3.33285 8.91995 3.47492 9.06203C3.61699 9.2041 3.69681 9.39679 3.69681 9.59771C3.69681 9.79864 3.61699 9.99133 3.47492 10.1334C3.33285 10.2755 3.14015 10.3553 2.93923 10.3553ZM6.72711 10.3553C6.52619 10.3553 6.3335 10.2755 6.19142 10.1334C6.04935 9.99133 5.96953 9.79864 5.96953 9.59771C5.96953 9.39679 6.04935 9.2041 6.19142 9.06203C6.3335 8.91995 6.52619 8.84014 6.72711 8.84014C6.92803 8.84014 7.12073 8.91995 7.2628 9.06203C7.40487 9.2041 7.48469 9.39679 7.48469 9.59771C7.48469 9.79864 7.40487 9.99133 7.2628 10.1334C7.12073 10.2755 6.92803 10.3553 6.72711 10.3553ZM12.7877 5.80984H10.515V4.29468H12.7877V5.80984ZM14.3029 10.3553C14.1019 10.3553 13.9093 10.2755 13.7672 10.1334C13.6251 9.99133 13.5453 9.79864 13.5453 9.59771C13.5453 9.39679 13.6251 9.2041 13.7672 9.06203C13.9093 8.91995 14.1019 8.84014 14.3029 8.84014C14.5038 8.84014 14.6965 8.91995 14.8386 9.06203C14.9806 9.2041 15.0604 9.39679 15.0604 9.59771C15.0604 9.79864 14.9806 9.99133 14.8386 10.1334C14.6965 10.2755 14.5038 10.3553 14.3029 10.3553Z"
        fill={color}
      />
    </svg>
  );
};

export const TripPlanV2Finish = ({ color = '#E0E0E0' }: { color?: string }) => {
  return (
    <svg
      width="514"
      height="130"
      viewBox="0 0 514 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M199.672 102.257H209.576V109.232H199.672V129.412H192V80.5488H212.316V87.5237H199.672V102.257Z"
        fill={color}
      />
      <path
        d="M215.996 80.5488H223.668V129.412H215.996V80.5488Z"
        fill={color}
      />
      <path
        d="M236.234 94.0285H236.077V129.412H229.188V80.5488H238.818L246.568 109.82H246.725V80.5488H253.575V129.412H245.629L236.234 94.0285Z"
        fill={color}
      />
      <path
        d="M259.017 80.5488H266.689V129.412H259.017V80.5488Z"
        fill={color}
      />
      <path
        d="M282.621 80C290.098 80 293.934 84.4671 293.934 92.3041V93.8323H286.692V91.7947C286.692 88.3072 285.283 86.9749 282.856 86.9749C280.429 86.9749 279.02 88.3072 279.02 91.7947C279.02 95.3605 280.546 98.0251 285.557 102.414C291.977 108.056 294.012 112.132 294.012 117.696C294.012 125.533 290.098 130 282.582 130C275.066 130 271.151 125.533 271.151 117.696V114.718H278.393V118.205C278.393 121.693 279.92 122.947 282.386 122.947C284.813 122.947 286.379 121.693 286.379 118.205C286.379 114.639 284.852 111.975 279.842 107.586C273.422 101.944 271.386 97.8683 271.386 92.3041C271.308 84.4671 275.144 80 282.621 80Z"
        fill={color}
      />
      <path
        d="M306.069 129.452H298.397V80.5488H306.069V101.513H314.798V80.5488H322.627V129.412H314.798V108.488H306.069V129.452Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H514V2H0V0ZM0 46H514V48H0V46ZM17.7241 6H0V23.9999H17.7231V41.996H35.4471V23.9999H53.1708V6H35.4467V23.9961H17.7241V6ZM301.308 6H283.584V23.9999H301.308V6ZM141.792 6H159.516L159.516 23.9961H177.239V6H194.963V23.9999H177.24V41.996H159.516L159.516 23.9999H141.793V41.996H124.069V23.9999H106.346V6H124.07V23.9961H141.792V6ZM443.101 6H425.377V23.9999H443.101V6ZM70.8964 6H88.6204V23.9961H106.344V41.996H88.6197V23.9999H70.8973V41.996H53.1733V23.9961H70.8964V6ZM372.203 6H354.479V23.9961H336.757V41.996H354.481V23.9999H372.203V6ZM212.689 6H230.413V23.9961H248.136V41.996H230.412V23.9999H212.69V41.996H194.966V23.9961H212.689V6ZM514 6H496.276V23.9999H514V6ZM336.756 23.9999H319.035V41.996H301.311V23.9961H319.032V6H336.756V23.9999ZM478.548 23.9999H460.828V41.996H443.104V23.9961H460.824V6H478.548V23.9999ZM389.928 23.9961H372.204V41.996H389.928V23.9961ZM389.931 6H407.655V23.9961H425.376V41.996H407.651V23.9999H389.931V6ZM265.862 6H248.138V23.9999H265.86V41.996H283.584V23.9961H265.862V6ZM496.275 23.9961H478.551V41.996H496.275V23.9961Z"
        fill={color}
      />
    </svg>
  );
};

export const TripPlanV3Complete = ({
  color = '#EEEEEE',
}: {
  color?: string;
}) => {
  return (
    <svg
      width="511"
      height="32"
      viewBox="0 0 511 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-3 0H511V2H-3V0ZM-3 6H6.84779V16.0011H-3V6ZM26.5455 6H16.6978V16.0011H26.4565V25.9991H36.3043V15.998H26.5455V6ZM41 21.1304V10.8696C41 7.62319 42.6232 6 45.8696 6H53.6087L55.5507 7.50725V9.76812H46.0435C45.4638 9.76812 45.1739 10.058 45.1739 10.6377V21.3623C45.1739 21.942 45.4638 22.2319 46.0435 22.2319H55.5507V24.4928L53.6087 26H45.8696C42.6232 26 41 24.3768 41 21.1304ZM59.3594 21.1304V10.8696C59.3594 7.62319 60.9826 6 64.2289 6H70.8376C74.084 6 75.7072 7.62319 75.7072 10.8696V21.1304C75.7072 24.3768 74.084 26 70.8376 26H64.2289C60.9826 26 59.3594 24.3768 59.3594 21.1304ZM63.5333 21.3623C63.5333 21.942 63.8231 22.2319 64.4028 22.2319H70.6637C71.2434 22.2319 71.5333 21.942 71.5333 21.3623V10.6377C71.5333 10.058 71.2434 9.76812 70.6637 9.76812H64.4028C63.8231 9.76812 63.5333 10.058 63.5333 10.6377V21.3623ZM80.4429 6V26H84.6168V13.3623L89.3125 23.3913H92.7908L97.4864 13.3623V26H101.66V6H96.6748L91.0516 18L85.4284 6H80.4429ZM106.7 26V6H116.439C119.685 6 121.308 7.62319 121.308 10.8696V14.7536C121.308 18 119.685 19.6232 116.439 19.6232H110.874V26H106.7ZM110.874 15.8551H116.265C116.845 15.8551 117.135 15.5652 117.135 14.9855V10.6377C117.135 10.058 116.845 9.76812 116.265 9.76812H110.874V15.8551ZM125.455 6V26H138.267V22.2319H129.629V6H125.455ZM141.607 26V6H155.288V9.76812H145.781V13.8261H154.418V17.5942H145.781V22.2319H155.288V26H141.607ZM157.691 6V9.76812H163.778V26H167.952V9.76812H174.038V6H157.691ZM177.392 26V6H191.073V9.76812H181.565V13.8261H190.203V17.5942H181.565V22.2319H191.073V26H177.392ZM314 6H323.848V16.0011H314V6ZM402.392 6H392.544V16.0011H402.392V6ZM451.849 6H461.696V16.0011H451.849V6ZM284.456 6H274.608V15.998H264.762V25.9991H274.609V16.0011H284.456V6ZM215.695 6H225.543V16.0011H215.696V25.9991H205.848V15.998H215.695V6ZM441.784 6H431.937V16.0011H441.784V6ZM353.393 6H363.241V15.998H372.848V25.9991H363V16.0011H353.393V6ZM412.239 15.998H402.393V25.9991H412.241V16.0011H422.087V6H412.239V15.998ZM491.241 6H501.089V15.998H510.848V25.9991H501V16.0011H491.241V6ZM333.697 16.0011H343.543V6H333.695V15.998H323.85V25.9991H333.697V16.0011ZM481.391 16.0011H471.546V25.9991H461.698V15.998H471.543V6H481.391V16.0011ZM284.457 15.998H294.304V25.9991H284.457V15.998ZM225.543 15.998H235.391V25.9991H225.543V15.998ZM254.913 6H264.761V16.0011H255.086V25.9991H245.238V16.0011H235.393V6H245.24V15.998H254.913V6ZM205.848 6H196V16.0011H205.848V6ZM304.154 6H294.306V16.0011H304.152V25.9991H314V15.998H304.154V6ZM372.85 6H382.697V15.998H392.543V25.9991H382.695V16.0011H372.85V6ZM431.936 15.998H422.088V25.9991H431.936V15.998ZM491.24 15.998H481.393V25.9991H491.24V15.998ZM343.544 15.998H353.392V25.9991H343.544V15.998ZM16.6969 15.998H6.84912V25.9991H16.6969V15.998ZM442 15.998H451.848V25.9991H442V15.998ZM511 30H-3V32H511V30Z"
        fill={color}
      />
    </svg>
  );
};

export const DriverHOSEventView = ({
  color = 'rgba(0, 17, 34, 0.75)',
}: {
  color?: string;
}) => {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 2C11.9473 2.00177 13.8271 2.71372 15.287 4.0024C16.7469 5.29107 17.6866 7.06798 17.93 9H13.86C13.6389 8.14353 13.1401 7.38451 12.4416 6.84169C11.7432 6.29887 10.8846 6.00287 10 6C9.11544 6.00287 8.25679 6.29887 7.55836 6.84169C6.85993 7.38451 6.36114 8.14353 6.14 9H2.07C2.31341 7.06798 3.25315 5.29107 4.71303 4.0024C6.17292 2.71372 8.05271 2.00177 10 2ZM10 12C9.46957 12 8.96086 11.7893 8.58579 11.4142C8.21071 11.0391 8 10.5304 8 10C8 9.46957 8.21071 8.96086 8.58579 8.58578C8.96086 8.21071 9.46957 8 10 8C10.5304 8 11.0391 8.21071 11.4142 8.58578C11.7893 8.96086 12 9.46957 12 10C12 10.5304 11.7893 11.0391 11.4142 11.4142C11.0391 11.7893 10.5304 12 10 12ZM2.07 11H6.14C6.31956 11.6879 6.67919 12.3154 7.18188 12.8181C7.68457 13.3208 8.31214 13.6804 9 13.86V17.93C7.23998 17.7068 5.60408 16.9049 4.34959 15.6504C3.0951 14.3959 2.29319 12.76 2.07 11ZM11 17.93V13.86C11.6879 13.6804 12.3154 13.3208 12.8181 12.8181C13.3208 12.3154 13.6804 11.6879 13.86 11H17.93C17.7068 12.76 16.9049 14.3959 15.6504 15.6504C14.3959 16.9049 12.76 17.7068 11 17.93Z"
        fill={color}
      />
    </svg>
  );
};
export const ReSequenceStopIcon = ({
  color = '#2B64CB',
}: {
  color?: string;
}) => {
  return (
    <svg
      width="20"
      height="10"
      viewBox="0 0 20 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 10L10 0L20 10H0Z" fill={color} />
    </svg>
  );
};
